<template>
  <SoWidget plain no-border class="devices-widget">
    <div v-if="loading" class="d-flex flex-column gap-2">
      <SoSkeleton
        v-for="i in 3"
        :key="i"
        type="card"
        data-testid="loading-skeleton"
      />
    </div>

    <template v-else-if="meterpoints?.data?.length">
      <DeviceDetails
        v-for="(meterpoint, index) in meterpoints.data"
        :key="index"
        :meterpoint="meterpoint"
        :smart-meter="getSmartMeter(meterpoint).data"
        class="mb-3"
        data-testid="device-details"
      />
      <IhdDetails
        v-if="noMeterInSupply"
        data-testid="ihd-not-in-supply"
        disabled
      ></IhdDetails>
      <template v-else-if="ihdDetails.length">
        <IhdDetails
          v-for="(ihd, key) in ihdDetails"
          :key="key"
          :ihd="ihd"
          data-testid="ihd-details"
          class="mb-3"
        >
        </IhdDetails>
      </template>
      <IhdDetails v-else data-testid="no-ihd" />
    </template>

    <SoAlert
      v-else
      type="info"
      title="No meterpoint details available"
      data-testid="no-meterpoints-alert"
    />

    <div class="mt-3 d-flex justify-end">
      <SoButton
        title="Send Feedback"
        data-testid="feedback-button"
        @click="openFeedbackModal"
      />
    </div>
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { typeformIds } from "@/constants/typeformIds"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"
  import { SmartMeterService } from "@/services/operations/SmartMeterService"
  import { MeterpointService } from "@/services/MeterpointService"
  import TypeformService from "@/services/TypeformService"
  import SoAlert from "@/components/SoAlert.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import DeviceDetails from "../components/DeviceDetails.vue"
  import IhdDetails from "../components/IhdDetails.vue"

  export default defineComponent({
    components: {
      DeviceDetails,
      SoWidget,
      IhdDetails,
      SoButton,
      SoSkeleton,
      SoAlert,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
        typeformIds,
      }
    },
    computed: {
      meterpoints() {
        return MeterpointService.getForAccount(this.current.accountNumber)
      },
      loading() {
        return (
          this.meterpoints.isFetching ||
          this.meterpoints.data.some(
            (meterpoint) => this.getSmartMeter(meterpoint)?.isFetching,
          ) ||
          this.current.ihdDetails.isFetching
        )
      },
      ihdDetails() {
        return this.current.ihdDetails.data
      },
      noMeterInSupply() {
        return this.meterpoints.data.every(
          (meterpoint) => meterpoint.supplyStatus === "NotSupplied",
        )
      },
    },
    methods: {
      getSmartMeter(meterpoint: IMeterpoint) {
        return SmartMeterService.getSmartMeter(meterpoint.identifier)
      },
      openTypeformModal(typeformId: string) {
        TypeformService.openPopup(typeformId, {
          height: 500,
          width: 700,
        })
      },
      openFeedbackModal() {
        this.openTypeformModal(typeformIds.SMART_DEVICES_FEEDBACK)
      },
    },
  })
</script>
